import apiClient from "./apiClient";

// Define the student services
const studentServices = {
  getUnassignedStudents: (classroomId) => {
    return apiClient.get(`/unassigned-students/${classroomId}`);
  },
  assignStudents: (payload) => {
    return apiClient.post("/assign", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  generateStudentReport: (studentId) => {
    return apiClient.get(`/student-report/${studentId}`, {
      responseType: "blob",
    });
  },
  getStudentChallengeStats: (lessonId) => {
    return apiClient.get(`/student-lesson-stats/${lessonId}`);
  },
  getStudentTrophies: (studentID) => {
    const url = studentID ? `/student-trophies/${studentId}` : `/student-trophies`;
    return apiClient.get(url);
  },
  getLineOfCode: (studentID) => {
    return apiClient.get(`/student-code-lines/${studentID}`);
  },
  generateUsername: (studentName) => {
    return apiClient.get(`/generate-username?name=${studentName}`);
  },
  getStudentRandomChallenge: (lessonID, difficulty) => {
    return apiClient.get(`/random-challenge/${lessonID}?difficulty=${difficulty}`);
  },
  getGraduationProject: (lessonID) => {
    return apiClient.get(`/lesson-graduation/${lessonID}`);
  },

  getStudentCodeProject: (lessonID) => {
    return apiClient.get(`/student-code-lesson/${lessonID}`);
  },
  getStudentByID: (studentId) => {
    const url = studentId ? `/student/${studentId}` : "/student";
    return apiClient.get(url);
  },
  getStudentByUserID: (userId) => {
    return apiClient.get(`/student-by-user-id/${userId}`);
  },
  exportProject: (projectID) => {
    return apiClient.get(`/export-project/${projectID}`, {
      responseType: "blob",
    });
  },
  getStudentQuestionsAnswers: (lessonID, studentID) => {
    return apiClient.get(`/student-questions/${lessonID}/${studentID}`);
  },

  getStudentCourses: (studentId) => {
    const url = studentId ? `/student-course/${studentId}` : `/student-course`;
    return apiClient.get(url);
  },
  saveOrPublishStudentProjects: (payload, projectID) => {
    const url = projectID ? `/submit-project/${projectID}` : `/submit-project`;
    return apiClient.post(url, payload);
  },
  saveOrPublishStudentChallenges: (payload, projectID) => {
    const url = `/student-challenge/${projectID}`;
    return apiClient.post(url, payload);
  },
  submitLessonProject: (lessonID, payload) => {
    const url = `/student-submit-lesson/${lessonID}`;
    return apiClient.post(url, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  getStudentProjects: (type, IDEType, studentId, lessonID) => {
    const path = studentId ? `/student-projects/${studentId}` : `/student-projects`;

    let query = [];
    if (type) query.push(`type=${type}`);
    if (IDEType) query.push(`ide_type=${IDEType}`);
    if (lessonID) query.push(`lesson_id=${lessonID}`);

    const queryString = query.length ? `?${query.join("&")}` : "";

    return apiClient.get(`${path}${queryString}`);
  },

  getStudentProjectsStats: (id) => {
    const url = id ? `/student-projects-stats/${id}` : `/student-projects-stats`;
    return apiClient.get(url);
  },
  getStudentScoreStats: (id) => {
    const url = id ? `/student-score/${id}` : `/student-score`;
    return apiClient.get(url);
  },
  getStudentLessons: (studentId) => {
    const url = studentId ? `/student-lessons/${studentId}` : `/student-lessons`;
    return apiClient.get(url);
  },

  unassignStudent: (studentId) => {
    return apiClient.get(`/unassign/${studentId}`);
  },
  addNewStudent: (payload) => {
    return apiClient.post(`/students`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  editStudentProfile: (studentId, payload) => {
    return apiClient.post(`/student/${studentId}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  deleteStudent: (studentId) => {
    return apiClient.delete(`/student/${studentId}`);
  },

  getStudentProject: (projectID) => {
    return apiClient.get(`/student-project/${projectID}`);
  },

  // GET: Method to get student profile
  getProfile: (params = {}, headers = {}) => {
    return apiClient.get("/student/profile", {
      params,
      headers,
    });
  },

  // GET: Method to get messages
  getMessages: (params = {}, headers = {}) => {
    return apiClient.get("/messages", {
      params,
      headers,
    });
  },

  // POST: Method to create a new student profile
  createProfile: (payload = {}, headers = {}) => {
    return apiClient.post("/student/profile", payload, {
      headers,
      options: {
        withoutToken: true, // Skip access_token
        withoutLanguage: true, // Skip language
      },
    });
  },

  // PUT: Method to update a student profile
  updateProfile: (payload = {}, headers = {}) => {
    return apiClient.put("/student/profile", payload, {
      headers,
    });
  },

  // DELETE: Method to delete a student profile
  deleteProfile: (params = {}, headers = {}) => {
    return apiClient.delete("/student/profile", {
      params,
      headers,
    });
  },

  // Additional methods can be added as needed
};

export default studentServices;
